import { makeStyles } from 'tss-react/mui';

import { scrollBar } from '@assets/mixins';

const useStyles = makeStyles()(() => ({
  box: {
    display: 'flex',
    height: '100%',
  },
  modalChildren: {
    height: 'initial',
  },
  modal: {
    height: 'initial',
    ...scrollBar,
  },
}));

export default useStyles;
